import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteNotesService {

  constructor(private http: HttpClient) { }

  public getAllNotesBySiteId(id, pagination) {
    const from = new Date('2018-01-01').getTime();
    const to = new Date().getTime();
    const dateString = '?startDate=' + from + '&endDate=' + to;

    const sortingString = '&sort=notesLastUpdated,desc';

    let paginationString = '';
    paginationString += '&size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http.get(environment.apiUrl + 'api/ext-user-session/for-dates-and-ids/list' + dateString + sortingString + paginationString + '&siteId=' + id, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  private handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
